"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WelcomePopup = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const WelcomePopup = (props) => {
    const [numStep, setNumStep] = (0, react_1.useState)(1);
    const { userStore, authStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const finishShowingWelcomePopup = () => __awaiter(void 0, void 0, void 0, function* () {
        props.onClose();
        userStore.setUserViewedWelcomePopup();
    });
    const goToPortal = () => __awaiter(void 0, void 0, void 0, function* () {
        navigate(navigation_1.default.home.root());
        yield finishShowingWelcomePopup();
    });
    const startRegistration = () => __awaiter(void 0, void 0, void 0, function* () {
        if (authStore.isLoggedIn) {
            navigate(navigation_1.default.registrationRightsholder.form());
        }
        else {
            navigate(navigation_1.default.signUp.root());
        }
        yield finishShowingWelcomePopup();
    });
    return (react_1.default.createElement("div", { className: "main-block" },
        react_1.default.createElement("img", { onClick: finishShowingWelcomePopup, className: `close ${numStep === 2 ? 'white' : ''}`, src: common_1.ICONS.close, alt: "close" }),
        react_1.default.createElement("div", { className: "welcome-popup" },
            numStep === 1 && (react_1.default.createElement("div", { className: "intro-step" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, "Welcome to The MLC Portal!"),
                    react_1.default.createElement("p", null, "Please note that you need access to a Member account to take any action in the Portal.")),
                react_1.default.createElement("img", { src: common_1.ILLUSTRATIONS.illustration4, alt: "illustration" }))),
            numStep === 2 && (react_1.default.createElement("div", { className: 'second-step' },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, "View the Portal"),
                    react_1.default.createElement("p", null, "If you were invited to an existing Member account to help manage the account, you can go straight to the Portal. Click the button below to get started.Please note that the features you see in the Portal depend on which user type you are."),
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: goToPortal }, "View the Portal")),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, "Or create a Member"),
                    react_1.default.createElement("p", null, "If you are responsible for collecting digital audio mechanical royalties, you will need to setup a Member to collect those royalties. At The MLC, a \"Member\" is the entity through which you collect royalties - think of it as a business or company!"),
                    react_1.default.createElement(Button_1.Button, { mainColor: false, type: 'primary', onClick: startRegistration }, "Create a Member")))),
            react_1.default.createElement("div", { className: "footer-block" },
                react_1.default.createElement("div", { className: "steps" },
                    react_1.default.createElement("div", { className: 'active', onClick: () => {
                            setNumStep(1);
                        } }),
                    react_1.default.createElement("div", { className: `${numStep === 2 ? 'active' : ''}`, onClick: () => {
                            setNumStep(2);
                        } })),
                numStep === 1 && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: common_1.ICONS.arrow_forward, onClick: () => {
                        setNumStep(2);
                    } }, 'Next'))))));
};
exports.WelcomePopup = WelcomePopup;
